export default __webpack_public_path__ + "static/media/bg7.0dfea56a.png";